import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import RoutingIndex from "./Routing";
import FooterIndex from "./Components/Footer";

function App() {
  return (
    <div className="App">
      
      <RoutingIndex />
      <FooterIndex />
    </div>
  );
}

export default App;
